<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.buildingLandTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.longueur_terrain"
                                      prop="longueur_terrain"
                                     >
                            <el-input  v-mask="'#################'" v-model.number="post.longueur_terrain_a_batir" type="longueur_terrain_a_batir">
                                <div slot="append">M</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.largeur_terrain"
                                      prop="largeur_terrain_a_batir"
                                     >
                            <el-input  v-mask="'#################'" v-model.number="post.largeur_terrain_a_batir" type="largeur_terrain_a_batir">
                                <div slot="append">M</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.avec_pente">
                            <el-radio v-model="post.avec_pente" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.avec_pente" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.viabilise">
                            <el-radio v-model="post.viabilise" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.viabilise" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.lotissement">
                            <el-radio v-model="post.lotissement" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.lotissement" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.constructible">
                            <el-radio v-model="post.constructible" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.constructible" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.facade_construction_max"
                                      prop="facade_construction_max"
                                     >
                            <el-input  v-mask="'#################'" v-model.number="post.facade_construction_max" type="facade_construction_max">
                                <div slot="append">M</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.hauteur_maximum"
                                      prop="hauteur_maximum"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.hauteur_maximum" type="hauteur_maximum">
                                <div slot="append">M</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$labels.exposition">
                                <el-select
                                        v-model="post.exposition"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                            :key="expositionChoice"
                                            :label="expositionChoice"
                                            :value="expositionChoice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.belle_vue">
                            <el-radio v-model="post.belle_vue" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.belle_vue" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.environmentTitle')">
                            <el-select
                                    v-model="post.environnement"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :key="environnementChoice"
                                        :label="environnementChoice"
                                        :value="environnementChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.avec_vis_a_vis">
                            <el-radio v-model="post.avec_vis_a_vis" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.avec_vis_a_vis" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.certificat_urbanisme">
                            <el-radio v-model="post.certificat_urbanisme" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.certificat_urbanisme" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.shon"
                                      prop="shon"
                                      >
                            <el-input  v-mask="'#################'" v-model.number="post.shon" type="shon">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cos"
                                      prop="cos"
                                     >
                            <el-input type="number" v-model="post.cos" step="0.01">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <hr/>
                    <h3>{{ $t("posts.propertyPartnerTitle")}} :</h3>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerCompany')">
                            <el-input v-model="post.societe_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerLastname')">
                            <el-input v-model="post.nom_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerFirstname')">
                            <el-input v-model="post.prenom_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerPhone')">
                            <el-input v-model.number="post.telephone_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'

export default {
  name: 'PostEditImmoObject1310',
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = [
      'mitoyennete',
      'chauffage_energie',
      'style_construction',
      'type_construction',
      'type_livraison',
      'exposition',
      'environnement',
      'mandat_statut',
      'modalites_recuperation_charges_locatives',
      'devise_iso_4217',
      'honoraires_payeurs'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
